import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@Injectable()
export class ConfirmationDialogService {

  constructor(private modalService: NgbModal) { }

  public confirm(
    title: string,
    message: string,
    btnOkText: string = 'confirm',
    btnCancelText: string = 'cancel',
    dialogSize: 'sm'|'md'|'lg'|'xl' = 'md'): Promise<boolean> {
      const modalRef = this.modalService.open(ConfirmationDialogComponent, {
        size: dialogSize,
        scrollable: true,
        centered: true,
        backdrop: 'static', // Set the backdrop property here
      });
    //const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

}
